"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function HeroSection() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#fefce8] py-14 md:py-16">
      <div className="max-w-[900px] mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-[42px] font-black text-[#064e3b] leading-tight mb-4">
          {t("terms.h1")}
        </h1>
        <p className="text-base md:text-lg text-[#374151] max-w-[720px] mx-auto mb-3 leading-relaxed">
          {t("terms.intro")}
        </p>
        <p className="text-sm text-[#6b7280] italic">
          {t("terms.lastUpdated")}
        </p>
      </div>
    </section>
  );
}